import React from 'react';
import {
  getHeroContent, HeroImage, TopControls, TabContent, getTabLabel, InlineEditableText
} from './ThemeLayoutHelpers';
export default function PantryLayout({ p }) {
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: "Pantry staples",
    title: "Shelf-ready essentials with fast repeat ordering",
    subtitle: "A warmer storefront for everyday groceries, bulk staples, and household basics with structured discovery.",
  });
  const pages = ["products", "services", "details"];
  const activeProduct = p.activeTab || "products";
  const setActiveProduct = p.setActiveTab;
  const search = p.searchQuery || "";
  const setSearch = p.setSearchQuery;
  const selectedCategory = p.activeTab || "products";
  const setSelectedCategory = p.setActiveTab;
  const cartCount = p.cart?.reduce((sum, item) => sum + (item.cartQuantity || 1), 0) || 0;
  const store = {
    wishlistCount: p.wishlistCount || 0,
    handleWishlist: p.handleGoToWishlist,
    cartCount,
    handleCart: p.handleOpenCart,
  };
  const ProductGrid = () => <TabContent p={p} />;

  return (
    <div className="min-h-screen bg-[linear-gradient(180deg,#fff7eb_0%,#fffdf8_30%,#f6efe2_100%)] text-[#4f3417]">
      <div className="mx-auto w-full max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="grid gap-5 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="rounded-[2rem] border border-[#e7c78b] bg-[linear-gradient(145deg,#fff7e6_0%,#f6e4bf_100%)] p-6 shadow-[0_20px_55px_rgba(146,94,33,0.16)] sm:p-8">
            <span className="inline-flex items-center rounded-full border border-[#d9ae63] bg-white/70 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#9a6221]"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
            <h1 className="mt-4 max-w-xl text-3xl font-semibold tracking-tight text-[#5f3b16] sm:text-5xl"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
            <p className="mt-3 max-w-2xl text-sm text-[#7a5224] sm:text-base"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>

            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={() => p.setActiveTab("products")}
                className="rounded-xl bg-[#8a5a24] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#73491d]"
              >
                {text.shopNow || "Shop Now"}
              </button>
              <button
                type="button"
                onClick={() => p.setActiveTab("details")}
                className="rounded-xl border border-[#cfa25d] bg-white/70 px-5 py-3 text-sm font-semibold text-[#7a5224] transition hover:bg-white"
              >
                {text.learnMore || "Learn More"}
              </button>
            </div>

            <div className="mt-7 grid gap-3 sm:grid-cols-3">
              {[
                { label: "Staples", value: `${p.filteredProducts?.length || 0}+` },
                { label: "Household", value: `${p.filteredServices?.length || 0}` },
                { label: "Repeat Orders", value: "Easy" },
              ].map((item) => (
                <div key={item.label} className="rounded-2xl border border-[#ebcf9e] bg-white/75 px-4 py-3">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.15em] text-[#9a6221]">{item.label}</p>
                  <p className="mt-1 text-2xl font-semibold text-[#5f3b16]">{item.value}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="overflow-hidden rounded-[2rem] border border-[#e3c58d] bg-white shadow-[0_20px_50px_rgba(120,78,29,0.12)]">
            <HeroImage p={p} themeId="pantry" className="h-full min-h-[320px]">
              <div className="absolute inset-0 bg-gradient-to-t from-[#4f3417]/80 via-[#4f3417]/20 to-transparent pointer-events-none" />
              <div className="absolute inset-x-0 bottom-0 p-6 text-white">
                <p className="text-xs uppercase tracking-[0.22em] text-white/75">{p.storeInfo?.businessCategory || text.storeInfo || "Store Info"}</p>
                <h2 className="mt-2 text-3xl font-semibold leading-tight">{p.storeInfo?.businessName}</h2>
                <p className="mt-2 max-w-sm text-sm text-white/80">{text.exploreAllProducts || "Explore All Products"}</p>
              </div>
            </HeroImage>
          </div>
        </div>

        <div className="mt-5 rounded-[1.75rem] border border-[#e8cfaa] bg-[#fffaf1]/95 p-4 shadow-[0_10px_30px_rgba(120,78,29,0.08)]">
          <TopControls
            search={search}
            setSearch={setSearch}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            categories={pages}
            store={store}
            showCategoryInSearch={false}
            shellClassName="border-[#ecd6b4] bg-[#fffdf7]"
            searchClassName="h-11 border-[#e2c08a] bg-white text-[#5a3c19] placeholder:text-[#9f7a45] focus:ring-[#8a5a24]/20"
            selectClassName="h-11 border-[#e2c08a] bg-white text-[#5a3c19] focus:ring-[#8a5a24]/20"
            rightActionsClassName="gap-2"
            iconButtonClassName="border-[#e3c58f] bg-[#fff6e8] text-[#8a5a24] hover:bg-[#fcefd9]"
          />
        </div>

        <div className="mt-5 grid gap-4 lg:grid-cols-[220px_1fr]">
          <div className="rounded-[1.5rem] border border-[#e8cfaa] bg-[#fffaf1] p-3 shadow-[0_10px_24px_rgba(120,78,29,0.07)]">
            <p className="px-2 pb-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#9a6221]">
              {text.products || "Products"}
            </p>
            <div className="flex flex-col gap-2">
              {pages.map((page) => {
                const active = activeProduct === page;
                return (
                  <button
                    key={page}
                    type="button"
                    onClick={() => setActiveProduct(page)}
                    className={`rounded-2xl px-4 py-3 text-left text-sm font-semibold transition ${
                      active
                        ? "bg-[#8a5a24] text-white shadow-[0_10px_24px_rgba(138,90,36,0.24)]"
                        : "border border-[#ecd6b4] bg-white text-[#6a4721] hover:bg-[#fff4df]"
                    }`}
                  >
                    {getTabLabel(p, page, page === "details" ? "store-info" : "default")}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="rounded-[1.75rem] border border-[#e8cfaa] bg-white/92 p-4 shadow-[0_14px_36px_rgba(120,78,29,0.08)] sm:p-5">
            <ProductGrid />
          </div>
        </div>
      </div>
    </div>
  );
}